import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {Router} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {Provider} from 'react-redux';
import {store} from './store/store';
import reportWebVitals from './reportWebVitals';
import SimpleReactLightbox from 'simple-react-lightbox';
import ThemeContext from './context/ThemeContext';

export const history = createBrowserHistory();

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <SimpleReactLightbox>
                {/* <BrowserRouter> */}
                <Router history={history}>
                    <ThemeContext>
                        <App />
                    </ThemeContext>
                </Router>
                {/* </BrowserRouter> */}
            </SimpleReactLightbox>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);
reportWebVitals();
